export default {
  transactionTypes: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/transactionType/state.js